import DataProviders from "./DataProviders";
import AppInitialLoader from "../components/AppInitialLoader";
import InitialLoaderProvider from "../providers/InitialLoaderProvider";

interface InitializerProvidersProps {
  children: React.ReactNode;
}

/**
 * InitializerProviders is a wrapper component that combines the primary data providers
 * with the initial loading state management.
 *
 *  It is used to ensure that all essential data
 * is available before the application renders its main content.
 */
function InitializerProviders(props: InitializerProvidersProps) {
  return (
    <InitialLoaderProvider>
      <DataProviders>
        <AppInitialLoader>{props.children}</AppInitialLoader>
      </DataProviders>
    </InitialLoaderProvider>
  );
}

export default InitializerProviders;
